import { IconPropsType } from '..';

export const DocumentIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="10"
    height="14"
    viewBox="0 0 10 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M0.199921 0.599991V13.4H7.21592L9.99192 10.624V0.599991H0.199921ZM8.71192 10.0976H6.69592V12.12H1.47992V1.87999H8.71192V10.0976ZM2.56312 9.45759V8.17759H5.12312V9.45759H2.56312ZM2.56312 6.89759V5.61759H6.40312V6.89759H2.56312ZM2.56312 4.33759V3.05759H7.68312V4.33759H2.56312Z" />
  </svg>
);
